import { featureItems } from '@/mocks/animeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            三大核心优势，重新定义在线看动漫的体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={item.title}
              className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}